import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import Urls from './../api/Urls';
import Flight from './../models/Flight';
// import { getDummyData } from '../utils/commonUtils';

export function getOrderFlightItem(productVariantId) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.ORDER_DETAIL_ITEM_FLIGHT,
        endpointParams: { id: productVariantId },
        parser: (data) => new Flight(data.data),
    }).get();
}